import { TranslationEntry } from "@dgs/core";
import { DataFieldType } from "../../../../shared/types/dataField";
import { ContactAttribute, IContactAttributeResource } from "./contactAttribute";

export interface ContactFilterTranslationEntry {
	name: string;
}

export interface ContactFilterIndexResource {
	id: number;
	name: string;
	type: ContactFilterType;
}

export type ContactFilterOperator =
	| "EQUAL"
	| "NOT_EQUAL"
	| "CONTAINS"
	| "NOT_CONTAINS"
	| "WHERE_IN"
	| "GREATER_THAN_EQUAL"
	| "LESS_THAN_EQUAL"
	| "IS_EMPTY"
	| "IS_NOT_EMPTY"
	| "WHERE_IN_CONTAINS"
	| "BETWEEN";

export const contactRelationEntityTypeToColumns = {
	primaryEmail: ["email"],
	emails: ["email"],
	nonPrimaryEmails: ["email"],
	phones: ["phoneNumber"],
	primaryPhone: ["phoneNumber"],
	nonPrimaryPhones: ["phoneNumber"],
	addresses: ["street", "zip", "houseNumber", "city", "additionalInfo", "countryId"],
	primaryAddress: ["street", "zip", "houseNumber", "city", "additionalInfo", "countryId"],
	nonPrimaryAddresses: ["street", "zip", "houseNumber", "city", "additionalInfo", "countryId"],
	companies: ["id"],
	primaryCompany: ["id"],
	nonPrimaryCompanies: ["id"],
	distributionLists: ["id"],
	invitationLists: ["id"],
	tenants: ["id"],
	tags: ["id"],
	applications: ["status"],
	contactType: ["id"],
} as const;

export type ContactRelationEntityTypeToColumns = typeof contactRelationEntityTypeToColumns;
export type ContactRelationColumn =
	ContactRelationEntityTypeToColumns[keyof ContactRelationEntityTypeToColumns][number];

export interface IContactFilterItemRequest {
	contactAttributeId: number;
	operator: ContactFilterOperator;
	value: unknown;
	relationColumn: ContactRelationColumn | null;
}

export interface ContactFilterSaveRequest {
	translations: TranslationEntry<ContactFilterTranslationEntry>[];
	type: ContactFilterType;
	filterItems: IContactFilterItemRequest[];
	showInSidebar: boolean;
}

export interface ContactFilterItemFormValues {
	contactAttributeId: number;
	operator: ContactFilterOperator | null;
	value: unknown;
	relationColumn: ContactRelationColumn | null;
}

export type ContactFilterType = "system" | "public" | "personal" | "onDemand";

export interface ContactFilterFormValues {
	translations: TranslationEntry<ContactFilterTranslationEntry>[];
	type: ContactFilterType;
	filterItems: ContactFilterItemFormValues[];
	showInSidebar: boolean;
}

export interface IContactFilterItemResource {
	contactAttribute: IContactAttributeResource;
	operator: ContactFilterOperator;
	value: unknown;
	relationColumn: ContactRelationColumn | null;
}

export interface ContactFilterUpdateResource {
	id: number;
	translations: TranslationEntry<ContactFilterTranslationEntry>[];
	type: ContactFilterType;
	items: IContactFilterItemResource[];
	showInSidebar: boolean;
}

export interface ContactFilterOptionResource {
	id: number;
	name: string;
	type: ContactFilterType;
	lastUsed: string;
}

export type ContactFilterAttributeType = ContactAttribute["entityType"] | DataFieldType | ContactRelationColumn;
